import { Component } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'fe-projet-modal',
  templateUrl: './fe-projet-modal.component.html',
  styleUrls: ['./fe-projet-modal.component.scss']
})
export class FeProjetModalComponent {

  constructor(public dialogRef: MatDialogRef<FeProjetModalComponent>) {

  }
}
